export function omitObjectKeys<T extends object, K extends keyof T>({
  object,
  keysToOmit,
}: {
  object: T;
  keysToOmit: K[];
}): Omit<T, K> {
  const objectWithoutKeysToOmit = { ...object };
  keysToOmit.forEach((key) => delete objectWithoutKeysToOmit[key]);
  return objectWithoutKeysToOmit;
}
